import { AnalyticsContext } from '@carvana/eventable-clickstream';
import { useCallback, useContext, useMemo } from 'react';
import { useSelector } from 'react-redux';
import TagIds from '~/constants/common/tagIds';
import { useConfiguration } from '~/context/common/StaticContext';
import { useUserLocation } from '~/context/common/UserContext';
import { getVehicleDetails } from '~/selectors';

function usePriceDrop() {
  const { priceDropRestrictedStates } = useConfiguration();

  const { state } = useUserLocation();
  const {
    previousPrice = 0,
    price = 0,
    highlights
  } = useSelector(getVehicleDetails);
  const { trackEvent } = useContext(AnalyticsContext);
  const priceDrop = previousPrice && price && previousPrice - price;
  const hasPriceDropHighlight = useMemo(
    () =>
      highlights?.some(highlight => highlight.tagId === TagIds.PriceDrop) ??
      false,
    [highlights]
  );

  const restrictedState =
    !priceDropRestrictedStates || priceDropRestrictedStates.includes(state);

  const sendPriceDropEvent = useCallback(() => {
    if (!hasPriceDropHighlight) return;
    trackEvent('Price Drop Data', {
      price,
      previousPrice,
      isPriceDropRestrictedState: restrictedState
    });
  }, [
    hasPriceDropHighlight,
    previousPrice,
    price,
    restrictedState,
    trackEvent
  ]);

  const showPriceDrop = Boolean(
    previousPrice && previousPrice - price > 0 && hasPriceDropHighlight
  );

  return {
    previousPrice,
    price,
    priceDrop,
    restrictedState,
    showPriceDrop,
    sendPriceDropEvent
  };
}

export default usePriceDrop;
